<template>
  <div class="container-header" style="margin-bottom: 20px;">
  <b-row>
    <b-col sm="4" md="6" lg="6">
      <b-form @reset="onReset" onsubmit="return false">
        <b-form-row>
          <b-col>
            <b-input-group>
              <b-form-input
                @keyup.enter="query"
                type="search"
                v-model="form.searchKey"
                placeholder="Search here..."
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="query">
                  <i class="fa fa-search"></i>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-form-row>
      </b-form>
    </b-col>
  </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        searchKey: "",
        deStatusList: ["Y"],
      },
    };
  },
  methods: {
    query() {
      this.$emit("submit", this.form);
    },
    onReset() {
      this.$emit("reset");
      this.query();
    },
  },
  created() {
    this.onReset();
  },
  activated() {
    this.query();
  },
};
</script>

